import { render } from "./selectFile.vue?vue&type=template&id=4a4a152e&scoped=true&ts=true"
import script from "./selectFile.vue?vue&type=script&lang=ts"
export * from "./selectFile.vue?vue&type=script&lang=ts"

import "./selectFile.vue?vue&type=style&index=0&id=4a4a152e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4a152e"]])

export default __exports__